import { useState } from "react";
import type { FaqItem } from "@/mocks/faqs";

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [open, setOpen] = useState<number>(0);

  return (
    <div className="space-y-3">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div
            key={item.q}
            className={`overflow-hidden rounded-lg border transition-colors ${
              isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50"
            }`}
          >
            <button
              type="button"
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
              aria-expanded={isOpen}
            >
              <span className="font-heading text-base text-foreground-950">{item.q}</span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                  isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                }`}
              >
                <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
              </span>
            </button>
            {isOpen && (
              <div className="border-t border-background-100 px-5 py-4">
                <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}